import { useState, useEffect, useCallback } from "react";
import { useAuth0 } from "../../react-auth0-spa";
import { useAppContext } from "../../context";
import { fetchOrgDocs } from "./api";

// Carica i documenti della sola org. Espone `reload` per aggiornare dopo un'eliminazione.
export const useOrgDocumentsData = (orgId) => {
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";

  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      setLoading(true);
      const token = await getTokenSilently();
      const rows = await fetchOrgDocs(token, env, orgId);
      setDocs(rows);
      setError(null);
    } catch (e) {
      console.error("Errore caricamento documenti org:", e);
      setError("Errore nel caricamento dei documenti");
    } finally {
      setLoading(false);
    }
  }, [getTokenSilently, env, orgId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { docs, loading, error, reload };
};
